export var SOCIAL;
(function (SOCIAL) {
    SOCIAL["FACEBOOK"] = "FACEBOOK";
    SOCIAL["GOOGLE"] = "GOOGLE";
    SOCIAL["LINKEDIN"] = "LINKEDIN";
})(SOCIAL || (SOCIAL = {}));
export function isSocial(val) {
    if (typeof val !== 'string') {
        return false;
    }
    return ['FACEBOOK', 'GOOGLE', 'LINKEDIN'].includes(val);
}
export function isExtendedSocial(val) {
    if (typeof val !== 'string') {
        return false;
    }
    if (val === 'TRADITIONAL') {
        return true;
    }
    return isSocial(val);
}
export var urlTokens = ['workEmailVerifyToken'];
//# sourceMappingURL=types.js.map